import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Router, Switch, Route, Redirect } from "react-router-dom";
import { history } from "../../helpers/history";
import PrivateRoute from "../components/functional/PrivateRoute";
import IdleTimer from "react-idle-timer";
import Alert from "../components/ui/alert";
import * as actions from "../../store/actions";
import AppHeader from "./headers/AppHeader";
import AppFooter from "./footers/AppFooter";
import appRoutes from "../../routes/app";
import { bindActionCreators } from "redux";
import { apiService } from "../../services/api.service";
import { localStorageService } from "../../services";
import { ComplianceModal } from "../components/ui/modal";
import {
  saveKioskCompliance,
  recordComplianceAgreement,
  getComplianceConfig,
} from "../../services/compliance.service";
import { TIMEOUT_IN_MINUTES } from "../../config/api.config";
import NotFound from "../../containers/errorpages/NotFound";

const allowEnableValue = "Y";
class AppLayout extends Component {
  constructor(props) {
    super(props);
    this.idleTimer = null;
    this.onAction = this._onAction.bind(this);
    this.onActive = this._onActive.bind(this);
    this.onIdle = this._onIdle.bind(this);
    this.state = {
      showMenu: false,
      notifications: {},
      showComplianceModal: false,
      complianceText: "",
      complianceReminderDays: 0,
      complianceLoading: false,
    };
  }

  _onAction(e) {
    const { auth } = this.props;
    if (auth.loggedIn) {
      localStorageService.SetExpiresAtInMinutes();
    }
  }

  _onActive(e) {}

  _onIdle(e) {
    this.handleLogout();
  }

  handleToggleMenu = (e) => {
    this.setState({
      showMenu: !this.state.showMenu,
    });
  };

  handleLogout = (e) => {
    apiService.logout();
    this.props.actions.logout();
    history.push("/account/login");
  };

  componentDidMount() {
    history.listen((location, action) => {
      this.setState({ showMenu: false });
      if (action === "PUSH" && location.pathname === "/") {
        this.showComplianceModalIfNeeded();
      }
    });

    if (this.props.auth.loggedIn) {
      this.showComplianceModalIfNeeded();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      !prevProps.auth.loggedIn &&
      this.props.auth.loggedIn &&
      this.props.auth.user &&
      this.props.auth.user.ClientId
    ) {
      this.showComplianceModalIfNeeded();
    }
  }

  showComplianceModalIfNeeded = async () => {
    const { auth } = this.props;

    // Don't show compliance modal if user has password expiration
    if (auth && auth.user && auth.user.PasswordExpiration) {
      return;
    }

    // Wait a bit to ensure route change has completed
    await new Promise((resolve) => setTimeout(resolve, 150));

    // Check if we're on the change password page first
    const currentPath = history.location.pathname;

    if (currentPath === "/account/changepassword") {
      return;
    }

    if (auth && auth.user && auth.user.ClientId) {
      try {
        await saveKioskCompliance(auth.user.ClientId, "W");
      } catch (e) {
        console.warn("saveKioskCompliance failed:", e);
      }

      let complianceText = "";
      let complianceReminderDays = 7;
      try {
        const config = await getComplianceConfig(auth.user.ClientId);

        let data = config;
        if (config && typeof config === "object") {
          if ("data" in config && typeof config.data === "object") {
            data = config.data;
          } else if ("ComplianceText" in config) {
            data = config;
          } else if (typeof config === "string") {
            try {
              data = JSON.parse(config);
              console.log(data, "dataTEsting");
            } catch (e) {
              data = {};
            }
          }
        }

        complianceText = data.ComplianceText || "";
        complianceReminderDays = data.ComplianceReminderDays || 7;
      } catch (e) {
        console.error("getComplianceConfig failed:", e);
      }
      if (complianceText && complianceText.trim() !== "") {
        this.setState({
          showComplianceModal: true,
          complianceText,
          complianceReminderDays,
        });
      } else {
        console.log("ComplianceText empty, modal will not show.");
      }
    } else {
      console.log("auth.user.ClientId not found, compliance API not called.");
    }
  };

  handleComplianceAgree = async () => {
    // On Agree, hit RECORD_COMPLIANCE_AGREEMENT API
    const { auth } = this.props;
    if (auth && auth.user) {
      try {
        await recordComplianceAgreement(auth.user.ClientId, "W");
      } catch (e) {
        // Optionally handle error (show alert, etc)
      }
    }
    this.setState({ showComplianceModal: false });
  };

  renderComplianceModal() {
    const { showComplianceModal, complianceText } = this.state;
    return (
      showComplianceModal && (
        <ComplianceModal
          show={showComplianceModal}
          complianceText={complianceText}
          onAgree={this.handleComplianceAgree}
        />
      )
    );
  }

  render() {
    const { auth, alert, actions, showHeaderFooter } = this.props;
    return (
      <Fragment>
        {this.renderComplianceModal()}
        {auth.loggedIn && !localStorageService.isRememberMeChecked() && (
          <IdleTimer
            ref={(ref) => {
              this.idleTimer = ref;
            }}
            element={document}
            onActive={this.onActive}
            onIdle={this.onIdle}
            onAction={this.onAction}
            debounce={250}
            timeout={1000 * 60 * TIMEOUT_IN_MINUTES}
          />
        )}
        <Router history={history}>
          {showHeaderFooter && auth.loggedIn && (
            <AppHeader
              auth={auth}
              allowEnableValue={allowEnableValue}
              onLogout={this.handleLogout}
              showMenu={this.state.showMenu}
              onToggleMenu={this.handleToggleMenu}
            />
          )}
          <main
            id="main"
            className={
              showHeaderFooter
                ? `pcoded-content ${this.state.showMenu ? "full" : ""}`
                : ""
            }
          >
            <div className="pcoded-inner-content">
              <div className="main-body">
                <div className="page-wrapper">
                  <div className="page-body">
                    <Switch>
                      {appRoutes.map((prop, key) => {
                        if (prop.redirect) {
                          return (
                            <Redirect from={prop.path} to={prop.to} key={key} />
                          );
                        } else {
                          if (prop.auth) {
                            if (auth.user) {
                              if (
                                prop.path === "/PositiveIncidents" &&
                                auth?.user?.EnablePositiveIncidents !==
                                  allowEnableValue
                              ) {
                                return (
                                  <Redirect
                                    from={"/PositiveIncidents"}
                                    to={"/"}
                                    key={key}
                                  />
                                );
                              } else if (
                                prop.path === "/Messages" &&
                                auth?.user?.IsTOMREXMessages
                              ) {
                                return (
                                  <Redirect
                                    from={"/Messages"}
                                    to={"/"}
                                    key={key}
                                  />
                                );
                              } else if (
                                prop.path === "/Agenda/Add_Agenda" &&
                                auth?.user?.EnableAgendaRequests !==
                                  allowEnableValue
                              ) {
                                return (
                                  <Redirect
                                    from={prop.path}
                                    to={"/Agenda"}
                                    key={key}
                                  />
                                );
                              } else if (
                                prop.path === "/Financial" &&
                                auth?.user?.FinancialsType !== "R"
                              ) {
                                return (
                                  <Redirect
                                    from={prop.path}
                                    to={"/CommunityFinancial"}
                                    key={key}
                                  />
                                );
                              } else if (
                                prop.path === "/CommunityFinancial" &&
                                auth?.user?.FinancialsType !== "C"
                              ) {
                                return (
                                  <Redirect
                                    from={prop.path}
                                    to={"/Financial"}
                                    key={key}
                                  />
                                );
                              } else if (
                                prop.path === "/Wallet" &&
                                auth?.user?.FinancialsType !== "C"
                              ) {
                                return (
                                  <Redirect
                                    from={prop.path}
                                    to={"/Financial"}
                                    key={key}
                                  />
                                );
                              }
                            } else {
                              return <PrivateRoute {...prop} key={key} />;
                            }
                          }

                          return <Route {...prop} key={key} />;
                        }
                      })}
                      <Route path="*" component={NotFound} />
                    </Switch>
                  </div>
                </div>
              </div>
            </div>
          </main>
          {showHeaderFooter && auth.loggedIn && <AppFooter />}
        </Router>

        <Alert {...alert} onHideAlert={actions.hideAlert} />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    alert: state.alert,
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      logout: bindActionCreators(actions.logout, dispatch),
      hideAlert: bindActionCreators(actions.hideAlert, dispatch),
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppLayout);
